import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MessageCircle } from 'lucide-react';
import logo from '../logo-optimized.jpg';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-fud-gray pt-16 pb-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 text-center md:text-left mb-16">
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex items-center gap-2 mb-6 group">
              <div className="bg-fud-green p-1 rounded-xl group-hover:scale-110 transition-transform shadow-md flex items-center justify-center">
                <img src={logo} alt="FUD Logo" className="h-8 w-8 object-contain bg-white rounded-lg p-0.5" />
              </div>
              <h3 className="text-2xl font-black tracking-tight text-fud-dark">fudchat.com</h3>
            </Link>
            <p className="text-fud-gray-dark text-sm leading-relaxed max-w-xs">
              Your intelligent AI-powered assistant for navigating Federal University Dutse.
              Making campus life simpler, faster, and more accessible for everyone.
            </p>
            <div className="mt-8 flex gap-5 justify-center md:justify-start">
              <a href="https://www.facebook.com/profile.php?id=61588112228695" target="_blank" rel="noopener noreferrer" className="bg-fud-gray-light p-2.5 rounded-full text-fud-gray-dark hover:text-white hover:bg-fud-green transition-all transform hover:scale-110 shadow-sm" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="https://wa.me/2348034567890" target="_blank" rel="noopener noreferrer" className="bg-fud-gray-light p-2.5 rounded-full text-fud-gray-dark hover:text-white hover:bg-fud-green transition-all transform hover:scale-110 shadow-sm" aria-label="WhatsApp">
                <MessageCircle size={18} />
              </a>
              <a href="https://twitter.com/fudchat01" target="_blank" rel="noopener noreferrer" className="bg-fud-gray-light p-2.5 rounded-full text-fud-gray-dark hover:text-white hover:bg-fud-green transition-all transform hover:scale-110 shadow-sm" aria-label="X (Twitter)">
                <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.instagram.com/chatfud01?igsh=bnQzM2z3MHp2cjIx" target="_blank" rel="noopener noreferrer" className="bg-fud-gray-light p-2.5 rounded-full text-fud-gray-dark hover:text-white hover:bg-fud-green transition-all transform hover:scale-110 shadow-sm" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-black text-fud-dark uppercase tracking-widest text-xs mb-6">Explore</h4>
            <ul className="space-y-4 text-sm text-fud-gray-dark">
              <li><Link to="/about" className="hover:text-fud-green transition-colors font-medium">About FUDChat</Link></li>
              <li><Link to="/contact" className="hover:text-fud-green transition-colors font-medium">Contact Us</Link></li>
              <li><Link to="/faculties" className="hover:text-fud-green transition-colors font-medium">Faculties</Link></li>
              <li><Link to="/departments" className="hover:text-fud-green transition-colors font-medium">Departments</Link></li>
              <li><Link to="/facilities" className="hover:text-fud-green transition-colors font-medium">Facilities &amp; Amenities</Link></li>
              <li><Link to="/administration" className="hover:text-fud-green transition-colors font-medium">Administration</Link></li>
              <li><Link to="/map" className="hover:text-fud-green transition-colors font-medium">Campus Map</Link></li>
            </ul>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-black text-fud-dark uppercase tracking-widest text-[11px] mb-6">Academics</h4>
            <ul className="space-y-4 text-sm text-fud-gray-dark">
              <li><Link to="/postgraduate" className="hover:text-fud-green transition-colors font-medium">Postgraduate</Link></li>
              <li><Link to="/research" className="hover:text-fud-green transition-colors font-medium">Research</Link></li>
              <li><Link to="/scedl" className="hover:text-fud-green transition-colors font-medium">SCEDL</Link></li>
              <li><Link to="/notices" className="hover:text-fud-green transition-colors font-medium">Notices</Link></li>
              <li><Link to="/updates" className="hover:text-fud-green transition-colors font-medium">Updates</Link></li>
              <li><Link to="/documents" className="hover:text-fud-green transition-colors font-medium">Documents</Link></li>
            </ul>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-black text-fud-dark uppercase tracking-widest text-[11px] mb-6">Legal &amp; Support</h4>
            <ul className="space-y-4 text-sm text-fud-gray-dark">
              <li><Link to="/disclaimer" className="hover:text-fud-green transition-colors font-medium">Disclaimer</Link></li>
              <li><Link to="/privacy" className="hover:text-fud-green transition-colors font-medium">Privacy Policy</Link></li>
              <li><a href="mailto:support@fudchat.com" className="hover:text-fud-green transition-colors font-medium break-safe">support@fudchat.com</a></li>
            </ul>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-black text-fud-dark uppercase tracking-widest text-xs mb-6">University</h4>
            <p className="text-sm text-fud-gray-dark leading-loose font-medium">
              Federal University Dutse<br />
              P.M.B. 7156, Ibrahim Aliyu Way,<br />
              Dutse, Jigawa State, Nigeria
            </p>
            <a
              href="https://fud.edu.ng"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 text-xs font-bold text-fud-green hover:underline"
            >
              Official university site →
            </a>
          </div>
        </div>
        <div className="pt-8 md:pt-12 border-t border-fud-gray flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6 text-xs md:text-sm font-bold text-fud-gray-dark">
          <p>© 2026 fudchat.com. Built for Federal University Dutse.</p>
          <p className="flex flex-wrap items-center justify-center gap-1.5 uppercase tracking-tighter text-center">
            <span>Developed by FUD students under</span>
            <a href="https://grownexhub.com" target="_blank" rel="noopener noreferrer" className="text-fud-green hover:underline">Grownex Hub</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
